import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
// our components
import ReviewRulesDetails from 'components/ReviewRules/Details';

const ScreenReviewRulesDetails = props => {
  const { classes, match } = props;
  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12}>
          <ReviewRulesDetails rule={match.params.rule} id={match.params.id} />
        </GridItem>
      </GridContainer>
    </div>
  );
};

ScreenReviewRulesDetails.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenReviewRulesDetails);
